import { render, staticRenderFns } from "./UserAuthorization.vue?vue&type=template&id=fd5ddc34&scoped=true"
import script from "./UserAuthorization.vue?vue&type=script&lang=js"
export * from "./UserAuthorization.vue?vue&type=script&lang=js"
import style0 from "./UserAuthorization.vue?vue&type=style&index=0&id=fd5ddc34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5ddc34",
  null
  
)

export default component.exports